export const useData=_ref=>{let{pageSize:pageSize=10,page:page,totalItems:totalItems}=_ref;return{hasMoreData:Boolean(totalItems&&totalItems>page*pageSize)}};